import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 번역 파일
const resources = {
  ko: {
    translation: {
      // 공통
      "loading": "로딩 중...",
      "close": "닫기",
      "cancel": "취소",
      "confirm": "확인",
      "delete": "삭제",
      "participants": "참여자",
      "completed": "완료",
      "select": "선택",
      
      // 홈 페이지
      "home": {
        "title": "새 이벤트 만들기",
        "eventName": "이벤트 이름 (예: PS5 래플)",
        "gameType": "게임 타입",
        "rps": "가위바위보",
        "tarot": "타로카드",
        "pets": "강아지/고양이",
        "winnerCount": "당첨자 수",
        "winnerCountHint": "1-100명 입력 가능",
        "productImage": "상품 이미지",
        "imageGuide": "카카오톡/SNS에 예쁘게 공유되려면 1200×630px 비율의 가로형 이미지를 권장합니다",
        "productDescription": "상품 설명",
        "productDescriptionPlaceholder": "상품에 대해 설명해주세요.",
        "deliveryMethod": "수령 방법 (선택)",
        "deliveryMethodPlaceholder": "당첨자에게 어떻게 전달할지 알려주세요.",
        "createEvent": "+Create",
        "creating": "만드는 중...",
        "myEvents": "내 이벤트",
        "noEvents": "아직 만든 이벤트가 없어요\n첫 이벤트를 만들어보세요!",
        "shareInfo": "이벤트를 만들면 공유 링크가 생성돼요\n링크를 SNS에 공유하세요!",
        "chooseFile": "이미지 파일 선택"
      },
      
      // 이벤트 페이지
      "event": {
        "answer": "당첨",
        "ranking": "{{rank}}등",
        "shareLink": "링크 공유",
        "copyLink": "링크 복사하기",
        "copied": "✓ 복사됨!",
        "creatorOnly": "크리에이터 전용",
        "announceResult": "결과 발표하기",
        "resultAnnounced": "결과 발표 완료",
        "correctAnswer": "크리에이터의 선택",
        "winners": "당첨자",
        "winnerCount": "{{count}}명",
        "phase1": "1차: 당첨자 {{count}}명",
        "phase2": "2차: 랜덤 추첨 {{count}}명",
        "randomDraw": "참가 순서와 무관하게 완전 랜덤 추첨되었습니다.",
        "participantNumber": "#{{number}}",
        "contactInfo": "당첨자 연락처",
        "waitingContact": "당첨자가 연락처를 입력하길 기다리는 중...",
        "participantsList": "참여자 ({{count}}명)",
        "noParticipants": "아직 참여자가 없어요",
        "participated": "참여 완료",
        "participatedMessage": "참여 완료!",
        "waitResult": "결과 발표를 기다려주세요.",
        "resultAnnounced2": "결과가 발표되었어요!",
        "winnerCheck": "당첨자 확인",
        "winnerNumbers": "당첨자 번호: {{numbers}}",
        "submitContact": "위 번호에 당첨되셨다면\n연락처를 입력해주세요.",
        "email": "이메일",
        "emailPlaceholder": "your@email.com",
        "address": "배송 주소 (선택사항)",
        "addressPlaceholder": "서울시 강남구...",
        "submitContactButton": "연락처 전달하기 →",
        "contactPrivate": "크리에이터만 볼 수 있습니다.",
        "contactSubmitted": "연락처 전달 완료!",
        "creatorWillContact": "크리에이터가 곧 연락드릴 거예요.",
        "selectAnswer": "선택하세요",
        "onlyCorrectWin": "같은 선택을 한 참여자만 당첨됩니다.",
        "rock": "바위",
        "paper": "보",
        "scissors": "가위",
        "backToMyEvents": "← 내 이벤트 보기",
        "poweredBy": "Powered by",
        "step1": "1차: 같은 선택 {{count}}명",
        "step2": "2차: 랜덤 추첨 {{count}}명",
        "winnerContact": "당첨자 연락처",
        "winnerContactTitle": "당첨자 연락처",
        "randomSelectionInfo": "참가 순서와 무관하게 완전 랜덤 추첨되었습니다.",       
        "selectionComplete": "선정 완료",
        "winnerConfirmation": "당첨자 확인",
        "enterContactPrompt": "당쳠되셨다면 연락처를 입력해주세요.",
        "deliveryAddress": "배송지 주소(선택사항)",
        "loading": "로딩 중...",
        "selectCorrectAnswer": "무엇을 선택하실 건가요?",
        "onlyCorrectWins": "크리에이터와 같은 선택을 하면 당첨!",
        "contactSaveFailed": "연락처 저장에 실패했어요.",
        "winnersToSelect": "{{count}}명 추첨 예정",
        "winnersHint": "크리에이터와 같은 선택!",
        "editEvent": "이벤트 수정",
        "editSuccess": "수정 완료!",
        "saving": "저장 중...",
        "saveChanges": "저장하기",
        "selected": "선택됨",
        "selectUpTo": "최대 {{count}}개까지 선택 가능",
        "confirm": "확인",
        "announcingResult": "결과 발표...",
        "loserTitle": "🥲 아쉽지만 다음 기회에...",
        "loserMessage": "참여해 주셔서 감사합니다!\n다음에 더 좋은 이벤트로 찾아올게요.",
        "exploreOtherEvents": "다른 이벤트 둘러보기"


      },

      "header": {
    "language": "언어 설정 (LANGUAGE)",
    "logout": "로그아웃"
  },
  
    
  
      
      // 타로카드
      "tarot": {
        "fool": "바보",
        "magician": "마법사",
        "highPriestess": "여사제",
        "empress": "여황제",
        "emperor": "황제",
        "hierophant": "교황",
        "lovers": "연인",
        "chariot": "전차",
        "strength": "힘",
        "hermit": "은둔자",
        "wheelOfFortune": "운명의 바퀴",
        "justice": "정의",
        "hangedMan": "매달린 사람",
        "temperance": "절제",
        "star": "별",
        "moon": "달",
        "sun": "태양",
        "judgement": "심판",
        "world": "세계"
      },
      
      // 강아지/고양이
      "pets": {
        "germanShepherd": "독일 셰퍼드",
        "poodle": "푸들",
        "goldenRetriever": "골든 리트리버",
        "bulldog": "불독",
        "ragdoll": "렉돌",
        "siamese": "샴",
        "americanShorthair": "아메리칸 숏헤어"
      },
      
      // 알림 메시지
      "alerts": {
        "enterEventName": "이벤트 이름을 입력하세요!",
        "enterDescription": "상품 설명을 입력하세요!",
        "selectImage": "상품 이미지를 선택하세요!",
        "creatorCannotParticipate": "크리에이터는 참여할 수 없어요!",
        "alreadyParticipated": "이미 참여하셨어요!",
        "noParticipantsAlert": "참여자가 없어요!",
        "noCorrectAnswer": "{{answer}}를 선택한 사람이 없어요!",
        "fewerWinners": "같은 선택 한 사람이 {{count}}명이라 {{count}}명 모두 당첨시킬까요?",
        "fewerWinnersChoice": "같은 선택을 한 사람이 {{count}}명이라 {{count}}명 모두 당첨시킬까요?",
        "enterContact": "이메일 또는 연락처를 최소 1개 입력해주세요!",
        "contactSaved": "연락처가 전달되었습니다!",
        "confirmDelete": "정말 삭제하시겠어요? 참여자 데이터도 모두 삭제됩니다.",
        "deleteWarning": "모든 참여자 데이터가 삭제됩니다.",
        "deleted": "삭제되었습니다!",
        "eventNotFound": "이벤트를 찾을 수 없어요",
        "contactSavedMessage": "당첨 시 연락드릴게요!",
        "announceResultsFailed": "결과 발표에 실패했어요",
        "contactSaveFailed": "연락처 저장에 실패했어요",
        "copyFailed": "링크를 복사할 수 없습니다. 직접 복사해주세요:",
        "noChoice": "{{choice}}를 선택한 사람이 없어요!",
        "onlyCreatorCanDelete": "본인의 이벤트만 삭제할 수 있어요!",
        "deleteFailed": "삭제에 실패했어요. 다시 시도해주세요.",
        "editFailed": "수정에 실패했어요",
        "noChoiceMultiple": "{{choices}}를 선택한 사람이 없어요!",
        "participationFailed": "참여에 실패했어요. 다시 시도해주세요.",
        "createEventFailed": "이벤트 생성에 실패했습니다. 잠시 후 다시 시도해 주세요.",
        "logoutFailed": "로그아웃에 실패했습니다. 다시 시도해주세요."


      },
       "logout": {
    "title": "로그아웃 하시겠어요?",
    "cancel": "취소",
    "confirm": "로그아웃"
  },

  "about": {
  "back": "뒤로가기",
  "description": "크리에이터와 참여자를 연결하는 투명한 경품 추첨 플랫폼. 좋아하는 크리에이터와 같은 선택을 하고 당첨되세요!",
  "madeBy": "만든 곳",
  "contact": "문의하기",
  "contactMessage": "궁금한 점, 피드백, 버그 제보 등 언제든 연락주세요!"
}
      
    }
  },


  en: {
    translation: {
      // Common
      "loading": "Loading...",
      "close": "Close",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "delete": "Delete",
      "participants": "Participants",
      "completed": "Completed",
      "select": "Select",
      
      // Home Page
      "home": {
        "title": "New Create Event",
        "eventName": "Event Name (e.g., PS5 Raffle)",
        "gameType": "Game Type",
        "rps": "Rock Paper Scissors",
        "tarot": "Tarot Cards",
        "pets": "Dogs & Cats",
        "winnerCount": "Number of Winners",
        "winnerCountHint": "Enter 1-100",
        "productImage": "Product Image",
        "imageGuide": "For best results when sharing on KakaoTalk/social media, we recommend a landscape image at a 1200×630px ratio",
        "productDescription": "Product Description",
        "productDescriptionPlaceholder": "Describe your product",
        "deliveryMethod": "Delivery Method (Optional)",
        "deliveryMethodPlaceholder": "Tell winners how they'll receive the prize",
        "createEvent": "+ Create",
        "creating": "Creating...",
        "myEvents": "My Events",
        "noEvents": "No events yet\nCreate your first event!",
        "shareInfo": "Share link will be generated\nShare it on social media!",
        "chooseFile": "Choose image file"
      },
      
      // Event Page
      "event": {
        "answer": "Answer",
        "ranking": "{{rank}}th",
        "shareLink": "Share Link",
        "copyLink": "Copy Link",
        "copied": "✓ Copied!",
        "creatorOnly": "Creator Only",
        "announceResult": "Announce Results",
        "resultAnnounced": "Results Announced",
        "correctAnswer": "CREATOR'S CHOICE",
        "winners": "Winners",
        "winnerCount": "{{count}} winner(s)",
        "phase1": "Phase 1: {{count}} correct answer(s)",
        "phase2": "Phase 2: Random draw {{count}} winner(s)",
        "randomDraw": "Winners selected randomly, regardless of participation order",
        "participantNumber": "#{{number}}",
        "contactInfo": "Winner Contact Info",
        "waitingContact": "Waiting for winner to submit contact info...",
        "participantsList": "Participants ({{count}})",
        "noParticipants": "No participants yet",
        "participated": "Participated",
        "participatedMessage": "Participated!",
        "waitResult": "Please wait for results",
        "resultAnnounced2": "Results announced!",
        "winnerCheck": "Winner Check",
        "winnerNumbers": "Winner numbers: {{numbers}}",
        "submitContact": "If your number is listed above,\nplease submit your contact info",
        "email": "Email",
        "emailPlaceholder": "your@email.com",
        "address": "Delivery Address (Optional)",
        "addressPlaceholder": "123 Main St...",
        "submitContactButton": "Submit Contact Info →",
        "contactPrivate": "Only visible to creator",
        "contactSubmitted": "Contact Info Submitted!",
        "creatorWillContact": "Creator will contact you soon",
        "selectAnswer": "Select Your Choice",
        "onlyCorrectWin": "Only matching selections will win",
        "rock": "Rock",
        "paper": "Paper",
        "scissors": "Scissors",
        "backToMyEvents": "← Back to My Events",
        "poweredBy": "Powered by",
        "step1": "Step 1: {{count}} matching choice(s)",
        "step2": "Step 2: Random {{count}}",
        "winnerContact": "Winner Contact",
        "winnerContactTitle": "Contact Information",
        "randomSelectionInfo": "Completely random selection, regardless of participation order",
        "selectionComplete": "Selection Complete",
        "winnerConfirmation": "Winner Confirmation",
        "enterContactPrompt": "If you won with the number above, please enter your contact info.",
        "deliveryAddress": "Delivery Address (Optional)",
        "loading": "Loading...",
        "selectCorrectAnswer": "What Will You Choose?",
        "onlyCorrectWins":  "Match the creator's choice to win!",
        "winnersToSelect": "{{count}} winner(s) will be selected",
        "winnersHint": "Good luck!",
        "editEvent": "Edit Event",
        "editSuccess": "Event updated!",
        "saving": "Saving...",
        "saveChanges": "Save Changes",
        "selected": "selected",
        "selectUpTo": "Choose up to {{count}} option(s)",
        "confirm": "Confirm",
        "announcingResult": "Announcing Results...",
        "loserTitle": "🥲 Better luck next time...",
        "loserMessage": "Thank you for participating!\nWe'll be back with better events.",
       "exploreOtherEvents": "Explore Other Events"

      },
      "header": {
    "language": "LANGUAGE",
    "logout": "Logout"
  },
      
      // Tarot Cards
      "tarot": {
        "fool": "The Fool",
        "magician": "The Magician",
        "highPriestess": "The High Priestess",
        "empress": "The Empress",
        "emperor": "The Emperor",
        "hierophant": "The Hierophant",
        "lovers": "The Lovers",
        "chariot": "The Chariot",
        "strength": "Strength",
        "hermit": "The Hermit",
        "wheelOfFortune": "Wheel of Fortune",
        "justice": "Justice",
        "hangedMan": "The Hanged Man",
        "temperance": "Temperance",
        "star": "The Star",
        "moon": "The Moon",
        "sun": "The Sun",
        "judgement": "Judgement",
        "world": "The World"
      },
      
      // Pets
      "pets": {
        "germanShepherd": "German Shepherd",
        "poodle": "Poodle",
        "goldenRetriever": "Golden Retriever",
        "bulldog": "Bulldog",
        "ragdoll": "Ragdoll",
        "siamese": "Siamese",
        "americanShorthair": "American Shorthair"
      },
      
      // Alert Messages
      "alerts": {
        "enterEventName": "Please enter event name!",
        "enterDescription": "Please enter product description!",
        "selectImage": "Please select product image!",
        "creatorCannotParticipate": "Creator cannot participate!",
        "alreadyParticipated": "You already participated!",
        "noParticipantsAlert": "No participants yet!",
        "noCorrectAnswer": "No one selected {{answer}}!",
        "fewerWinners": "Only {{count}} correct answer(s). Select all {{count}}?",
        "fewerWinnersChoice": "Only {{count}} people selected the same. Select all {{count}}?",
        "enterContact": "Please enter at least email or phone!",
        "contactSaved": "Contact info submitted!",
        "contactSavedMessage": "You'll be notified if you win!",
        "confirmDelete": "Delete this event?",
        "deleteWarning": "All participant data will be deleted.",
        "deleted": "Deleted!",
        "eventNotFound": "Event not found",
        "announceResultsFailed": "Failed to announce results",
        "contactSaveFailed": "Failed to save contact info",
        "copyFailed": "Unable to copy link. Please copy manually:",
        "noChoice": "No one selected {{choice}}!",
        "onlyCreatorCanDelete": "Only the creator can delete this event!",
        "deleteFailed": "Failed to delete. Please try again.",
        "editFailed": "Failed to update event",
        "noChoiceMultiple": "No one selected: {{choices}}!",
        "participationFailed": "Failed to participate. Please try again.",
        "createEventFailed": "Failed to create the event. Please try again.",
        "logoutFailed": "Failed to log out. Please try again."
      },
    

      "logout": {
    "title": "Log out?",
    "cancel": "Cancel",
    "confirm": "Log out"
  },

     "about": {
  "back": "Back",
  "description": "A transparent raffle platform connecting creators and participants. Choose the same as your favorite creator and win!",
  "madeBy": "Made by",
  "contact": "Contact",
  "contactMessage": "Questions, feedback, or bug reports? We'd love to hear from you!"
}
    }
  }
};

i18n
  .use(LanguageDetector) // 자동 언어 감지
  .use(initReactI18next) // React 연동
  .init({
    resources,
    fallbackLng: 'ko', // 기본 언어
    supportedLngs: ['ko', 'en'], // 지원 언어
    
    interpolation: {
      escapeValue: false // React는 XSS 자동 방지
    },
    
    detection: {
      order: ['localStorage', 'navigator'], // 언어 감지 우선순위
      caches: ['localStorage'] // localStorage에 저장
    }
  });

export default i18n;
